import { useConfigurationIntValue } from "./useConfigurationIntValue";

// Returns a number representing the desired polling interval in milliseconds
export function usePollingInterval(): number {
  return useConfigurationIntValue("POLLING_INTERVAL", 6000);
}
